import React from "react";
import { useSelector } from "react-redux";
import { Route } from "react-router-dom";
import { useFlags } from "launchdarkly-react-client-sdk";
import { selectOrgHierarchySelectedOrg, selectOrgList } from "../store/selectors/orgHierarchy.selectors";
import OrgHierarchyButton from "../shared/components/orgHierarchy/OrgHierarchyButton";

const OrgHierarchyPrivateRoute = (props) => {
  const { children, path, ...other } = props;
  const selectedOrg = useSelector(selectOrgHierarchySelectedOrg); 
  const orgs = useSelector(selectOrgList);
  const {
    enableOrgHierarchyModule
  } = useFlags();
  const isAllow = !selectedOrg?.children || selectedOrg?.children?.length === 0 || !enableOrgHierarchyModule || orgs?.length <= 10;
  return (
    <Route
      path={path}
      render={() => (isAllow ? (
        <>
          {children}
        </>
      ) : (
        <div className='d-flex flex-column align-items-center font-xl border-radius-5 bg-color-lightgray p-5'>
          <div>Please select a child org:</div>
          <OrgHierarchyButton title="Choose an Organization" className="glympse-orgHierarchy-wrapper" buttonClassName="glympse-text-orange" />
        </div>
      ))}
      {...other}
    />
  );
};

export default OrgHierarchyPrivateRoute;